export const environment = {
  production: false,
  isDev: false,
  searchApiEndpointUrl: 'https://app.dnv.org/dnv_search/',
  // problemsApiEndpointUrl: 'api/problems',
  // gisUrl: 'api/gis/',
  problemsApiEndpointUrl: 'https://raptest.dnv.org/api/problems',
  gisUrl: 'https://raptest.dnv.org/api/gis/'
};
